import { Divider, TextField, Chip, MenuItem } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useUpdatePaymentMutation } from "../../../store/paymentApi";
import { convertToInputDateTime } from "../../../utilits/helpers/convertDateFormat";
import Modal from "../../UI/Modal";
import InputAdornment from "@mui/material/InputAdornment";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import Contragenty from "../../spravochniki/contragent/Contragenty";
import Dogovora from "../dogovor/Dogovora";
import { useGetPaymentCodeQuery } from "../../../store/paymentCodeApi";

export default function Payment({ item, onClose, id }) {
  const {data: paymentCodeFB} = useGetPaymentCodeQuery()
  const [updateData] = useUpdatePaymentMutation();
  const [docDate, setDocDate] = React.useState(
    convertToInputDateTime(new Date(item.attributes.dateTime))
  );
  const [docNumber, setDocNumber] = React.useState(item.attributes.docNumber);
  const [amount, setAmount] = React.useState(item.attributes.amount);
  //   const [type, setType] = React.useState("");
  const [contragent, setContragent] = React.useState(
    item.attributes.dogovor.data[0].attributes.contragent.data[0].attributes
      .surname +
      " " +
      item.attributes.dogovor.data[0].attributes.contragent.data[0].attributes
        .name +
      " " +
      item.attributes.dogovor.data[0].attributes.contragent.data[0].attributes
        .lastname
  );
  const [dogovor, setDogovor] = React.useState(item.attributes.dogovor.data[0].attributes.numberDogovor);
  const [inn, setInn] = React.useState(item.attributes.dogovor.data[0].attributes.contragent.data[0].attributes.inn);
  const [totalSum, setTotalSum] = React.useState(item.attributes.dogovor.data[0].attributes.totalSum);
  const [dateDogovorFrom, setDateDogovorFrom] = React.useState(item.attributes.dogovor.data[0].attributes.dateDogovorFrom);
  const [dateDogovorTo, setDateDogovorTo] = React.useState(item.attributes.dogovor.data[0].attributes.dateDogovorTo);
  const [modalForContragenty, setModalForContragenty] = React.useState(false);
  const [modalForDogovor, setModalForDogovor] = React.useState(false);
  const [contragentID, setContragentID] = React.useState(item.attributes.dogovor.data[0].attributes.contragent.data[0].id);
  const [dogovorID, setDogovorID] = React.useState(item.attributes.dogovor.data[0].id);
  const [invoice, setInvoice] = React.useState(item.attributes.dogovor.data[0].attributes.invoice);
  const [paymetCode, setPaymentCode] = React.useState([])
  const [paymentCodeID, setPaymentCodeID] = React.useState(item.attributes.payment_code.data[0].id)

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const paymentCodes = await paymentCodeFB.data;
        setPaymentCode(paymentCodes);
      } catch (error) {}
    };
    setDataToStates();
  }, [paymentCodeFB]);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const getContragentItem = (item) => {
    setContragent(
      item.attributes.surname +
        " " +
        item.attributes.name +
        " " +
        item.attributes.lastname
    );
    setInn(item.attributes.inn);
    setContragentID(item.id);
  };

  const getDogovorItem = (item) => {
    setDogovor(item.attributes.numberDogovor);
    setInvoice(item.attributes.invoice);
    setTotalSum(item.attributes.totalSum);
    setDogovorID(item.id);
    setDateDogovorFrom(item.attributes.dateDogovorFrom);
    setDateDogovorTo(item.attributes.dateDogovorTo);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.alert("Вы уверены?");
    const updated = {
      docNumber,
      dateTime: new Date(docDate),
      amount,
      type: "plus",
      contragent: contragentID,
      dogovor: dogovorID,
      user: 1,
      payment_code: paymentCodeID,
    };
    updateData({ updated, id });
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfCreation>Оплата</TitleOfCreation>
      <BlockStyled margin="0 0 20px 0" width="100%">
        <BlockStyled width="100%" display="flex" justifyContent="space-between">
          <TextFieldStylded
            id="datetime"
            type="datetime-local"
            InputLabelProps={{ shrink: true }}
            label="Дата документа"
            variant="outlined"
            value={docDate}
            onChange={(event) => inputChangeHandler(event, setDocDate)}
            size="small"
            width="200px"
            mrg="0 10px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="№ документа"
            variant="outlined"
            value={docNumber}
            onChange={(event) => inputChangeHandler(event, setDocNumber)}
            size="small"
            width="20%"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма"
            variant="outlined"
            value={amount}
            onChange={(event) => inputChangeHandler(event, setAmount)}
            size="small"
            width="150px"
            mrg="0 15px 0 0"
          />
          <TextFieldStylded
          id="select"
          select
          label="Код оплаты"
          variant="outlined"
          width="200px"
          size="small"
          value={paymetCode.length ? paymentCodeID : ""}
        >
          {paymetCode.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => setPaymentCodeID(item.id)}
              >
                {item.attributes.title}
              </MenuItem>
            );
          })}
        </TextFieldStylded>
        </BlockStyled>
        <BlockStyled
          width="100%"
          margin="20px 0 0 0"
          display="flex"
          gap="20px"
        >
          <TextFieldStylded
            InputLabelProps={{ shrink: true }}
            label="Контрагент"
            id="outlined-end-adornment"
            mrg="0 20px 0 0"
            size="small"
            width="45%"
            value={contragent}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconStyled
                    onClick={() => setModalForContragenty(true)}
                    color="primary"
                  />
                </InputAdornment>
              ),
            }}
          />
          <Modal
            fullwidth={"60%"}
            isOpen={modalForContragenty}
            onClose={() => setModalForContragenty(false)}
          >
            <Contragenty
              onCloseContragenty={() => setModalForContragenty(false)}
              getContragentItem={getContragentItem}
            />
          </Modal>
          <TextFieldStylded
            id="outlined-basic"
            label="ИНН"
            variant="outlined"
            value={inn}
            onChange={(event) => inputChangeHandler(event, setInn)}
            size="small"
            width="30%"
            mrg="0 20px 0 0"
          />
        </BlockStyled>
      </BlockStyled>
      <DividerStyled sx={{ margin: "20px 0" }} width="60%">
        <Chip label="Договор" />
      </DividerStyled>
      <BlockStyled
        margin="20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          label="Договор №"
          id="outlined-end-adornment"
          width="15%"
          value={dogovor}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconStyled
                  onClick={() => setModalForDogovor(true)}
                  color="primary"
                />
              </InputAdornment>
            ),
          }}
        />
        <Modal
          fullwidth={"60%"}
          isOpen={modalForDogovor}
          onClose={() => setModalForDogovor(false)}
        >
          <Dogovora
            onCloseDogovor={() => setModalForDogovor(false)}
            getDogovorItem={getDogovorItem}
          />
        </Modal>
        <TextFieldStylded
          id="outlined-basic"
          label="Лицевой счет"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          variant="outlined"
          value={invoice}
          onChange={(event) => inputChangeHandler(event, setInvoice)}
          width="15%"
          disabled
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Сумма договора"
          value={totalSum}
          onChange={(event) => inputChangeHandler(event, setTotalSum)}
          width="15%"
        />
        <BlockStyled
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0 10px"
          width="10px"
        >
          с
        </BlockStyled>
        <TextFieldStylded
          id="date"
          type="date"
          InputLabelProps={{ shrink: true }}
          label="Сроки договора"
          variang="outlined"
          value={dateDogovorFrom}
          onChange={(event) => inputChangeHandler(event, setDateDogovorFrom)}
          width="150px"
        />
        <BlockStyled
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0 10px"
          width="10px"
        >
          по
        </BlockStyled>
        <TextFieldStylded
          id="date"
          type="date"
          InputLabelProps={{ shrink: true }}
          label="Сроки договора"
          variant="outlined"
          value={dateDogovorTo}
          onChange={(event) => inputChangeHandler(event, setDateDogovorTo)}
          width="150px"
        />
      </BlockStyled>
      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        ></BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
  gap: ${(props) => props.gap};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const DividerStyled = styled(Divider)`
  margin: ${(props) => props.margin};
`;
const IconStyled = styled(MoreHorizTwoToneIcon)`
  cursor: pointer;
`;
const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
